(() => {
  const root=document.getElementById('edr-trustpilot');
  if(!root||root.dataset.ready)return;
  root.dataset.ready='true';
  const track=root.querySelector('.edr-reviews__track');
  const cards=[...root.querySelectorAll('.edr-reviews__card')];
  const prev=root.querySelector('[data-edr-review-prev]');
  const next=root.querySelector('[data-edr-review-next]');
  const position=root.querySelector('.edr-reviews__position');
  const dialog=root.querySelector('dialog');
  const close=dialog.querySelector('.edr-reviews__close');
  let opener,previousOverflow;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  function update(){
    const step=cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);
    const first=Math.min(cards.length,Math.round(track.scrollLeft/step)+1);
    const visible=Math.max(1,Math.floor((track.clientWidth+parseFloat(getComputedStyle(track).gap)+1)/step));
    position.textContent=(visible>1?first+'–'+Math.min(cards.length,first+visible-1):first)+' / '+cards.length;
    prev.disabled=track.scrollLeft<3;
    next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-3;
  }
  function move(direction){
    const step=cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);
    track.scrollBy({left:step*direction,behavior:reduced.matches?'auto':'smooth'});
  }
  prev.addEventListener('click',()=>move(-1));
  next.addEventListener('click',()=>move(1));
  track.addEventListener('scroll',update,{passive:true});
  track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1)}});
  new ResizeObserver(update).observe(track);
  cards.forEach(card=>{
    const quote=card.querySelector('.edr-reviews__quote');
    const more=card.querySelector('.edr-reviews__more');
    more.addEventListener('click',()=>{
      opener=more;
      dialog.querySelector('#edr-review-dialog-title').textContent=card.querySelector('h3').textContent;
      dialog.querySelector('.edr-reviews__full-quote').textContent=quote.textContent;
      dialog.querySelector('.edr-reviews__author').textContent=card.querySelector('.edr-reviews__author').textContent;
      previousOverflow=document.documentElement.style.overflow;
      document.documentElement.style.overflow='hidden';
      dialog.showModal();
      close.focus();
    });
  });
  close.addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()});
  dialog.addEventListener('close',()=>{document.documentElement.style.overflow=previousOverflow||'';opener?.focus({preventScroll:true})});
  update();
})();
